'use client';

export { default } from './AccordionGroup';
export * from './accordionGroupClasses';
export { default as accordionGroupClasses } from './accordionGroupClasses';
export * from './AccordionGroupProps';